var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mb-6",staticStyle:{"max-width":"100vw"}},[_c('cards')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }